import { Injectable } from '@angular/core';
import {
  FullTaxReportDto,
  FullTaxReport,
  FullTaxReportByIdDto,
  FullTaxReportById,
  UpdateFullTaxInvoicePayload,
} from '../../models/report/fulltax-report.model';

@Injectable({
  providedIn: 'root',
})
export class MapperFullTaxReportService {
  /**
   * Maps a single FullTaxReportDto response from API to FullTaxReport model
   */
  mapFullTaxFromDto(dto: FullTaxReportDto): FullTaxReport {
    return {
      id: dto.id,
      receiptId: dto.receiptId || '',
      customerName: dto.customerName || '',
      createBill: dto.createBill ? new Date(dto.createBill) : new Date(),
      siteName: dto.siteName || '',
      fee: dto.fee || 0,
      vat: dto.vat || 0,
      total: dto.total || 0,
      status: dto.status || '0',
      details: dto.details || '',
    };
  }

  /**
   * Maps FullTaxReportByIdDto response from API to FullTaxReportById model
   */
  mapFullTaxByIdFromDto(dto: FullTaxReportByIdDto): FullTaxReportById {
    const base = this.mapFullTaxFromDto(dto);
    return {
      ...base,
      name: dto.name || '',
      createDate: dto.createDate ? new Date(dto.createDate) : new Date(),
      reference: dto.reference || '',
      remark: dto.remark || '',
      cardName: dto.cardName || '',
      type: dto.type || '',
      paymentType: dto.paymentType || '',
      address: dto.address || '',
      taxId: dto.taxId || '',
      telephone: dto.telephone || '',
      email: dto.email || '',
      postcode: dto.postcode || '',
      headquarters: !!dto.headquarters,
      branchNo: dto.branchNo || null,
      cpAddressId: dto.cpAddressId || null,
      cpAddress: dto.cpAddress,
      items: dto.items || [],
    };
  }

  mapUpdatePayloadFromForm(
    form: FullTaxReportById,
    userId: number,
    menuId: number,
  ): UpdateFullTaxInvoicePayload {
    return {
      userId,
      menuId,
      id: form.id,
      customerName: form.customerName ?? '',
      createBill: form.createBill ? form.createBill.toISOString() : null,
      status: form.status ?? '',
      details: form.details ?? '',
      reference: form.reference ?? '',
      remark: form.remark ?? '',
      cardName: form.cardName ?? '',
      type: form.type ?? '',
      address: form.address ?? '',
      taxId: form.taxId ?? '',
      telephone: form.telephone ?? '',
      email: form.email ?? '',
      postcode: form.postcode ?? '',
      headquarters: !!form.headquarters,
      branchNo: form.headquarters ? '' : (form.branchNo ?? ''),
      cpAddressId: form.cpAddressId ?? null,
    };
  }

  mapActionResponse(res: unknown): { isSuccess: boolean; message: string } {
    const data = (res ?? {}) as Record<string, unknown>;
    return {
      isSuccess: !!(data['isSuccess'] ?? data['IsSuccess']),
      message: String(data['message'] ?? data['Message'] ?? 'เกิดข้อผิดพลาด'),
    };
  }

  /**
   * Maps search types to API query parameter field names
   */
  mapSearchField(searchType: 'receiptId' | 'customerName' | 'taxId'): string {
    switch (searchType) {
      case 'receiptId':
        return 'receiptId';
      case 'taxId':
        return 'taxId';
      default:
        return 'customerName';
    }
  }

  /**
   * Maps UI columns to database columns for sorting
   */
  mapSortColumn(column: string): string {
    switch (column) {
      case 'receiptId':
        return 'receiptId';
      case 'customerName':
        return 'customerName';
      case 'createBill':
        return 'createBill';
      case 'total':
        return 'total';
      default:
        return column || 'id';
    }
  }
}
